<template>
    <dx-drop-down-box
        ref="dropDownBoxRef"
        :data-source="dataSource"
        :display-expr="cellInfo.column.editor?.text"
        :value-expr="cellInfo.column.dataField"
        v-model:value="currentValue"
        :drop-down-options="{ minWidth: '250px', minHeight: minHeight }"
        :tab-index="cellInfo.columnIndex"
        :show-clear-button="showClearButton"
        @value-changed="clearField"
    >
        <div id="ai-grid-ro-content" :style="{ height: minHeight }">
            <component
                :is="getComponent()"
                :showToolbar="false"
                :showFilterPanel="false"
                :showGridFooter="false"
                :rowClickCallBack="rowClick"
                :args="cellInfo.column.componentMeta.args"
                :meta="cellInfo.column.componentMeta.meta"
                :cellInfo="cellInfo"
            />
        </div>
    </dx-drop-down-box>
</template>
<script>
/*
Чтобы кнопка Сбросить значение(Х) появилась в нужном столбце необходимо добавить в мету этого столбца настройку 'showClearButton: true' в editor.
Например, так - editor: { type: 'ai-drop-down', text: 'name_dep', showClearButton: true },
*/
export default {
    name: 'ai-drop-down',
};
</script>
<script setup>
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { ref, computed } from 'vue';
import { defineAsyncComponent } from 'vue';

const props = defineProps({
    cellInfo: {
        type: Object,
        default: () => {},
    },
    value: {
        type: Number,
    },
    onValueChanged: {
        type: Function,
        default: () => {},
    },
});

const currentValue = ref(props.value);
const dataSource = ref([]);
const dropDownBoxRef = ref(null);

const emit = defineEmits(['select', 'endEditing']);

const minHeight = computed(() => {
    return props.cellInfo.column.componentMeta.minHeight || '400px';
});

const getComponent = () => {
    const componentName = props.cellInfo.column.componentMeta.name;
    if (componentName) return componentName;

    const componentPath = props.cellInfo.column.componentMeta.path;
    return defineAsyncComponent(() => import(`@/${componentPath}`));
};

const rowClick = ({ row, keyExpr }) => {
    const { dataField, editorMeta, componentMeta } = props.cellInfo.column;
    const updatedRow = {};

    updatedRow[dataField] = row[keyExpr];
    currentValue.value = row[keyExpr];
    updatedRow[editorMeta?.text] = row[componentMeta?.text];
    emit('select', { row: updatedRow, keyExpr: dataField });

    props.onValueChanged(currentValue.value);

    dropDownBoxRef.value?.instance?.close();
    emit('endEditing', props.cellInfo);
};

const showClearButton = computed(() => {
    return props.cellInfo.column.editorMeta?.showClearButton;
});

const clearField = e => {
    if (e.value === null) {
        props.onValueChanged?.(null);
    }
};
</script>
<style scoped>
#ai-grid-ro-content {
    height: 400px;
}

:deep(.dx-clear-button-area) {
    margin-left: 8px !important; /* Внешний отступ от поля ввода */
}
</style>
